import React, { useState } from "react";
import { ProviderContext, withSnackbar } from "notistack";
import FirebaseService from "../../services/firebase/FirebaseService";
import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import LoadingButton from "../Loading/LoadingButton";
import { Select, MenuItem, FormControl, FormLabel, TextField } from "@material-ui/core";
import { GENERAL_MAX_LENGTH } from "../../utils/stringFormatting";
import "./EditClassModal.scss";

// Edit class modal

interface EditClassProps {
  classId: string;
  className: string;
  grade: string;
  open: boolean;
  cancelClose: () => void;
}

const gradesArray = ["K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

const EditClassModal = (props: EditClassProps & ProviderContext) => {
  const [loadingButtonState, setLoadingButtonState] = useState(LoadingButton.BeforeLoading);
  const [grade, setGrade] = useState(props.grade);
  const [className, setClassName] = useState(props.className);

  const updateGradeDropdown = (event: React.ChangeEvent<{ value: unknown }>) => {
    setGrade(event.target.value as string);
  };
  const updateClassName = (event: React.ChangeEvent<{ value: unknown }>) => {
    setClassName(event.target.value as string);
  };

  const save = () => {
    if (className.length === 0) {
      props.enqueueSnackbar("Cannot save empty class name.", {
        variant: "error",
        autoHideDuration: 5000,
      });
    } else {
      FirebaseService.updateClassInfo(props.classId, className, grade)
        .then(() => {
          props.cancelClose();
          props.enqueueSnackbar("Class information updated.", {
            variant: "success",
            autoHideDuration: 5000,
          });
        })
        .catch(() => {
          props.enqueueSnackbar("Could not update class info.", {
            variant: "error",
            autoHideDuration: 5000,
          });
        });
    }
    setLoadingButtonState(LoadingButton.BeforeLoading);
  };

  return (
    <StandardModal
      cancelClose={props.cancelClose}
      onSubmit={save}
      changeLoadingButtonState={setLoadingButtonState}
      loadingButtonState={loadingButtonState}
      title={<div className="title">Edit Class Information</div>}
      open={props.open}
      size={ModalSize.large}
      onlyOneButton={false}
      submitButtonText="Save"
      className="EditClass"
    >
      <div className="body">
        <FormControl variant="outlined" style={{ marginBottom: "30px" }}>
          <FormLabel className="label">Class Name</FormLabel>
          <TextField
            value={className}
            variant="outlined"
            id="school"
            onChange={updateClassName}
            inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
            fullWidth
          />
        </FormControl>
        <FormControl variant="outlined" className="grade">
          <FormLabel className="label">Grade</FormLabel>
          <Select value={grade} onChange={updateGradeDropdown}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {gradesArray.map(name => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </StandardModal>
  );
};

export default withSnackbar(EditClassModal);
